import * as Api from '../../utils/request'


export default {
    //获取分享的数据
    async msgReport(data){
        return await Api.postForm({
            url:'/H5/msg_report.html',
            data:data,
        })
    },
}
